import type {
  RyftOrderPaymentInitiatePathParametersType,
  RyftOrderPaymentInitiateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";

export const useRyftManagementOrderPaymentInitiate = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: ({ orderId }: RyftOrderPaymentInitiatePathParametersType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `ryft-management/orders/${orderId}/payment-sessions`,
      }).then(
        (response) =>
          apiV2AssertResponse<RyftOrderPaymentInitiateResponseType>(response)
            .data,
      ),
  });
};
